import { useMutation } from '@tanstack/react-query';

import type { CreateSavedListOutreachQueueRequestDTO } from '../dto';
import { CreateSavedListOutreachQueue } from '../api';

export const useCreateSavedListOutreachQueue = () => {
  return useMutation({
    mutationFn: (params: {
      listId: string;
      request: CreateSavedListOutreachQueueRequestDTO;
    }) => CreateSavedListOutreachQueue(params.listId, params.request),
  });
};
